import { Box, Typography } from "@mui/material";
import { KivuFMSLogo } from "../../../assets";
import React, { useContext } from "react";
import { useNavigate } from "react-router";
import {
  KivuI18nContext,
  localizedPath,
  useKivunovaTranslation,
  copyrightText,
  PAGE_ROUTE_DOWNLOAD_APPS
} from "@kivunova/kivufrontendcommon";
import { isEmbeddedShellActive } from "../../../Utils/embeddedShellSession";
import { isShowFirstVisitDownloadDialogEnabled } from "../../../Utils/firstVisitDownloadDialogEnv";

import {
  authBackgroundContainerSx,
  authOrb1Sx,
  authOrb2Sx
} from "./authBackgroundStyles";

const AuthSidePanel = () => {
  const navigate = useNavigate();
  const { language, defaultLang } = useContext(KivuI18nContext);
  const { t } = useKivunovaTranslation();

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        p: { md: 4 },
        ...authBackgroundContainerSx
      }}
      data-testid="auth-left-panel"
    >
      <Box sx={authOrb1Sx} />
      <Box sx={authOrb2Sx} />

      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          position: "relative",
          zIndex: 1,
          px: 2
        }}
      >
        <Box sx={{ mb: 4 }}>
          <img
            src={KivuFMSLogo}
            alt="Kivunova FMS Logo"
            style={{
              width: "100%",
              maxWidth: 100,
              display: "block",
              margin: "0 auto"
            }}
            data-testid="auth-logo"
          />
        </Box>

        <Typography
          variant="h5"
          component="p"
          sx={{
            maxWidth: 520,
            lineHeight: 1.65,
            fontSize: { xs: "1.2rem", sm: "1.35rem" },
            fontWeight: 400,
            color: "rgba(255, 255, 255, 0.92)"
          }}
          data-testid="auth-left-text"
        >
          {t(
            "auth-side-panel-intro-text",
            "Re-imagining financial management experience with advance data analytics for optimum performance"
          )}
        </Typography>

        {!isEmbeddedShellActive() &&
          isShowFirstVisitDownloadDialogEnabled() && (
            <Typography
              component="button"
              type="button"
              onClick={() =>
                navigate(
                  localizedPath(PAGE_ROUTE_DOWNLOAD_APPS, language, defaultLang)
                )
              }
              sx={{
                mt: 3,
                color: "rgba(255,255,255,0.9)",
                textDecoration: "underline",
                cursor: "pointer",
                background: "none",
                border: "none",
                font: "inherit",
                fontSize: "0.95rem",
                maxWidth: 520
              }}
              data-testid="auth-download-apps-link"
            >
              {t(
                "welcome-download-apps-link",
                "Download apps for Windows, Mac, iPhone & Android"
              )}
            </Typography>
          )}
      </Box>

      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          justifyContent: "center",
          pb: 2,
          position: "relative",
          zIndex: 1
        }}
      >
        <Typography
          variant="caption"
          sx={{ color: "rgba(255, 255, 255, 0.8)" }}
          data-testid="auth-left-footer"
        >
          {copyrightText("Kivunova")}
        </Typography>
      </Box>
    </Box>
  );
};

export default AuthSidePanel;
